module.exports = __webpack_public_path__ + "img/part5-5.c79c4104.png";